import { type TagFilter, normalizeTagFilter } from '../components/TagFilterBuilder';

// Extra tag filter for batch review, shared by every batch in a project and kept apart
// from the Tag Explorer filter (PreferenceService.CurrentFilter). One key: a filter saved
// in another project is discarded, so it resets on project change like the grid filters.
const STORAGE_KEY = 'iio-batch-tag-filter';

export function loadBatchTagFilter(projectId: string): TagFilter | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const filter = normalizeTagFilter(raw ? JSON.parse(raw) : null, projectId);
    if (!filter) localStorage.removeItem(STORAGE_KEY);
    return filter;
  } catch {
    return null;
  }
}

export function saveBatchTagFilter(projectId: string, filter: TagFilter | null): void {
  try {
    if (filter && filter.size > 0) localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...filter, projectId }));
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage full or blocked: the filter still applies, it just won't be remembered.
  }
}

/** Drops a batch filter saved in another project. */
export function resetBatchTagFilterOnProjectChange(projectId: string): void {
  if (projectId) loadBatchTagFilter(projectId);
}
